import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, ArrowLeft, CheckCircle2 } from 'lucide-react';
export function EOIForm() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    venueName: '',
    venueCount: '1',
    venueType: 'Restaurant',
    bookingPlatform: '',
    challenge: '',
    interestLevel: 'Just exploring',
    timeframe: '0-3 months',
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  });
  const [isSuccess, setIsSuccess] = useState(false);
  const handleNext = () => setStep(s => s + 1);
  const handlePrev = () => setStep(s => s - 1);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('EOI Submission:', formData);
    setIsSuccess(true);
  };
  const updateForm = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  return <section id="eoi-form" className="py-32 bg-brand-black relative z-10 scroll-mt-32" data-id="element-386">
      <div className="max-w-2xl mx-auto px-6" data-id="element-387">
        <div className="text-center mb-16" data-id="element-388">
          <h2 className="text-4xl md:text-5xl font-display mb-6 leading-[1.0] tracking-tight text-white" data-id="element-389">
            Request Early Access.
          </h2>
          <p className="text-xl text-gray-400 font-light leading-relaxed" data-id="element-390">
            Join the waitlist for Aijentik Hospitality. We are onboarding select
            venues and groups for our initial rollout.
          </p>
        </div>

        <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-391">
          {/* Progress Bar */}
          {!isSuccess && <div className="mb-10" data-id="element-392">
              <div className="flex justify-between text-xs font-medium text-gray-500 uppercase tracking-widest mb-3" data-id="element-393">
                <span data-id="element-394">Step {step} of 4</span>
                <span data-id="element-395">
                  {step === 1 && 'About your venue'}
                  {step === 2 && 'Operations today'}
                  {step === 3 && 'Your plans'}
                  {step === 4 && 'Stay in the loop'}
                </span>
              </div>
              <div className="w-full h-1 bg-white/5 rounded-full overflow-hidden" data-id="element-396">
                <motion.div className="h-full bg-brand-orange" initial={{
              width: '25%'
            }} animate={{
              width: `${step / 4 * 100}%`
            }} transition={{
              duration: 0.5,
              ease: [0.16, 1, 0.3, 1]
            }} data-id="element-397" />
              </div>
            </div>}

          <AnimatePresence mode="wait" data-id="element-398">
            {!isSuccess ? <motion.form key="form" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.4,
            ease: [0.16, 1, 0.3, 1]
          }} onSubmit={step === 4 ? handleSubmit : e => e.preventDefault()} data-id="element-399">
                {/* STEP 1 */}
                {step === 1 && <div className="space-y-6" data-id="element-400">
                    <div data-id="element-401">
                      <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-402">
                        Venue or Group Name
                      </label>
                      <input type="text" required value={formData.venueName} onChange={e => updateForm('venueName', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder:text-gray-600 focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all" placeholder="e.g. The Grand Hotel" data-id="element-403" />
                    </div>
                    <div className="grid grid-cols-2 gap-4" data-id="element-404">
                      <div data-id="element-405">
                        <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-406">
                          Number of Venues
                        </label>
                        <select value={formData.venueCount} onChange={e => updateForm('venueCount', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all appearance-none" data-id="element-407">
                          <option value="1" data-id="element-408">1</option>
                          <option value="2-5" data-id="element-409">2-5</option>
                          <option value="6-20" data-id="element-410">6-20</option>
                          <option value="20+" data-id="element-411">20+</option>
                        </select>
                      </div>
                      <div data-id="element-412">
                        <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-413">
                          Venue Type
                        </label>
                        <select value={formData.venueType} onChange={e => updateForm('venueType', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all appearance-none" data-id="element-414">
                          <option value="Restaurant" data-id="element-415">Restaurant</option>
                          <option value="Bar" data-id="element-416">Bar</option>
                          <option value="Cafe" data-id="element-417">Cafe</option>
                          <option value="Hotel" data-id="element-418">Hotel</option>
                          <option value="Club" data-id="element-419">Club</option>
                          <option value="Function Venue" data-id="element-420">Function Venue</option>
                          <option value="Multi-concept" data-id="element-421">Multi-concept</option>
                          <option value="Other" data-id="element-422">Other</option>
                        </select>
                      </div>
                    </div>
                    <button type="button" onClick={handleNext} className="w-full mt-8 bg-brand-orange hover:bg-brand-deep-orange text-white px-6 py-4 rounded-xl font-medium transition-colors flex items-center justify-center gap-2" data-id="element-423">
                      Next <ArrowRight className="w-4 h-4" data-id="element-424" />
                    </button>
                  </div>}

                {/* STEP 2 */}
                {step === 2 && <div className="space-y-6" data-id="element-425">
                    <div data-id="element-426">
                      <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-427">
                        Current Booking Platform
                      </label>
                      <input type="text" value={formData.bookingPlatform} onChange={e => updateForm('bookingPlatform', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder:text-gray-600 focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all" placeholder="e.g. SevenRooms, ResDiary, OpenTable" data-id="element-428" />
                    </div>
                    <div data-id="element-429">
                      <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-430">
                        Biggest Operational Challenge
                      </label>
                      <textarea rows={4} value={formData.challenge} onChange={e => updateForm('challenge', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder:text-gray-600 focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all resize-none" placeholder="Tell us where you lose the most time..." data-id="element-431" />
                    </div>
                    <div className="flex gap-4 mt-8" data-id="element-432">
                      <button type="button" onClick={handlePrev} className="w-1/3 text-gray-400 hover:text-white px-6 py-4 font-medium transition-colors flex items-center justify-center gap-2" data-id="element-433">
                        <ArrowLeft className="w-4 h-4" data-id="element-434" /> Back
                      </button>
                      <button type="button" onClick={handleNext} className="w-2/3 bg-brand-orange hover:bg-brand-deep-orange text-white px-6 py-4 rounded-xl font-medium transition-colors flex items-center justify-center gap-2" data-id="element-435">
                        Next <ArrowRight className="w-4 h-4" data-id="element-436" />
                      </button>
                    </div>
                  </div>}

                {/* STEP 3 */}
                {step === 3 && <div className="space-y-6" data-id="element-437">
                    <div data-id="element-438">
                      <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-439">
                        Interest Level
                      </label>
                      <div className="space-y-2" data-id="element-440">
                        {['Just exploring', 'Actively looking', 'Ready to pilot', 'Ready to deploy'].map(level => <label key={level} className="flex items-center gap-3 p-4 border border-white/10 rounded-xl cursor-pointer hover:bg-white/5 transition-colors" data-id="element-441">
                            <input type="radio" name="interestLevel" value={level} checked={formData.interestLevel === level} onChange={e => updateForm('interestLevel', e.target.value)} className="accent-brand-orange w-4 h-4" data-id="element-442" />
                            <span className="text-white text-sm" data-id="element-443">{level}</span>
                          </label>)}
                      </div>
                    </div>
                    <div data-id="element-444">
                      <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-445">
                        Desired Rollout Timeframe
                      </label>
                      <select value={formData.timeframe} onChange={e => updateForm('timeframe', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all appearance-none" data-id="element-446">
                        <option value="0-3 months" data-id="element-447">0-3 months</option>
                        <option value="3-6 months" data-id="element-448">3-6 months</option>
                        <option value="6-12 months" data-id="element-449">6-12 months</option>
                        <option value="12+ months" data-id="element-450">12+ months</option>
                      </select>
                    </div>
                    <div className="flex gap-4 mt-8" data-id="element-451">
                      <button type="button" onClick={handlePrev} className="w-1/3 text-gray-400 hover:text-white px-6 py-4 font-medium transition-colors flex items-center justify-center gap-2" data-id="element-452">
                        <ArrowLeft className="w-4 h-4" data-id="element-453" /> Back
                      </button>
                      <button type="button" onClick={handleNext} className="w-2/3 bg-brand-orange hover:bg-brand-deep-orange text-white px-6 py-4 rounded-xl font-medium transition-colors flex items-center justify-center gap-2" data-id="element-454">
                        Next <ArrowRight className="w-4 h-4" data-id="element-455" />
                      </button>
                    </div>
                  </div>}

                {/* STEP 4 */}
                {step === 4 && <div className="space-y-6" data-id="element-456">
                    <div className="grid grid-cols-2 gap-4" data-id="element-457">
                      <div data-id="element-458">
                        <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-459">
                          First Name
                        </label>
                        <input type="text" required value={formData.firstName} onChange={e => updateForm('firstName', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all" data-id="element-460" />
                      </div>
                      <div data-id="element-461">
                        <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-462">
                          Last Name
                        </label>
                        <input type="text" required value={formData.lastName} onChange={e => updateForm('lastName', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all" data-id="element-463" />
                      </div>
                    </div>
                    <div data-id="element-464">
                      <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-465">
                        Work Email
                      </label>
                      <input type="email" required value={formData.email} onChange={e => updateForm('email', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all" data-id="element-466" />
                    </div>
                    <div data-id="element-467">
                      <label className="block text-xs uppercase tracking-[0.25em] text-gray-500 mb-3" data-id="element-468">
                        Phone (Optional)
                      </label>
                      <input type="tel" value={formData.phone} onChange={e => updateForm('phone', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-brand-orange/50 focus:bg-white/10 transition-all" data-id="element-469" />
                    </div>
                    <div className="flex gap-4 mt-8" data-id="element-470">
                      <button type="button" onClick={handlePrev} className="w-1/3 text-gray-400 hover:text-white px-6 py-4 font-medium transition-colors flex items-center justify-center gap-2" data-id="element-471">
                        <ArrowLeft className="w-4 h-4" data-id="element-472" /> Back
                      </button>
                      <button type="submit" className="w-2/3 bg-brand-orange hover:bg-brand-deep-orange text-white px-6 py-4 rounded-xl font-medium transition-colors flex items-center justify-center gap-2" data-id="element-473">
                        Submit EOI
                      </button>
                    </div>
                  </div>}
              </motion.form> : <motion.div key="success" initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="text-center py-12" data-id="element-474">
                <div className="w-20 h-20 bg-brand-orange/10 rounded-full flex items-center justify-center mx-auto mb-6 shadow-[0_0_30px_rgba(219,127,74,0.2)]" data-id="element-475">
                  <CheckCircle2 className="w-10 h-10 text-brand-orange" data-id="element-476" />
                </div>
                <h3 className="text-3xl font-display text-white mb-4" data-id="element-477">
                  You're officially on the list.
                </h3>
                <p className="text-gray-400 font-light mb-8 max-w-md mx-auto" data-id="element-478">
                  We'll be in touch within 48 hours about early access to
                  Aijentik Hospitality.
                </p>
                <a href="mailto:sales@aijentik.com" className="inline-block text-brand-orange hover:text-brand-deep-orange font-medium transition-colors text-sm" data-id="element-479">
                  Want to talk sooner? Email us →
                </a>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}